import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import { IoMdArrowForward } from 'react-icons/io';
import ContainedButton from '~/components/layout/form/containedButton';
import api from '~/services/api';
import { handleUserId } from '~/store/actions/user-actions';
import Loading from '~/components/layout/loading';
import theme from '~/styles/theme';
import phoneMask from '~/utils/phoneMask';
import InputSearch from './InputSearch';

import {
  AdressLineContainer,
  AdressLine,
  AdressItem,
  AdressName,
  AdressIcon,
  AdressNameContainer,
  AdressInfoContainer,
  Select,
  Hr,
  AddressContainer,
  AddressItemContainer,
  AddressButtonContainer,
  Title,
  FormHeader,
} from './styles';

class ListAddres extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      adresses: [],
      adressesOrder: [],
      adressesFiltered: [],
      bases: [],
      selectedAdress: null,
      redirect: false,
      token: '',
      phone: '',
      searchValue: '',
    };
  }

  requestGetCustomer = (token) => {
    const siteId = localStorage.getItem('@UltragazEmpresarial:customerSiteId');
    const loginEmail = localStorage.getItem('@UltragazEmpresarial:loginEmail');

    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };

    const parameters = {
      method: 'GET',
      headers: header,
      type: 'EMP',
      _expand: 'CONTACT',
    };

    api
      .get('industrial/customer/v1/customers/me', parameters)
      .then((res) => {
        const {
          data: { customerAddresses },
        } = res;

        const [address] = customerAddresses.filter(
          (customerAddress) =>
            customerAddress.addressType === 'SHIP_TO' &&
            customerAddress.siteId === siteId
        );

        if (!address) {
          return;
        }

        const { contacts } = address;

        if (contacts.length > 0) {
          const [phone] = contacts.filter(
            (contact) =>
              contact.contactType === 'PHONE' && contact.isValidated === true
          );
          const contactIdSf = contacts.filter(
            (contact) => contact.contact === loginEmail
          )[0]?.contactIdSf;

          if (contactIdSf) {
            localStorage.setItem(
              '@UltragazEmpresarial:contactIdSf',
              contactIdSf
            );
          }

          if (!phone) {
            return;
          }
          const contactPhone = phoneMask(phone.contact);
          localStorage.setItem('@UltragazEmpresarial:phone', contactPhone);
        }
      })
      .catch((err) => {
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  async componentDidMount() {
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
    this.setState({ loading: true, token });
    this.resetLocalStorage(token);
    this.requestGetCustomer(token);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { adresses } = this.state;
    if (adresses && adresses !== prevState.adresses) {
      adresses.sort(function (a, b) {
        if (a.address.name > b.address.name) {
          return 1;
        }
        if (a.address.name < b.address.name) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      this.setState({ adressesOrder: adresses, adressesFiltered: adresses });
    }
  }

  resetLocalStorage = (token) => {
    localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
    localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
    localStorage.removeItem('@UltragazEmpresarial:customerCode');
    localStorage.removeItem('@UltragazEmpresarial:customerId');
    localStorage.removeItem('@UltragazEmpresarial:customerName');
    localStorage.removeItem('@UltragazEmpresarial:city');
    localStorage.removeItem('@UltragazEmpresarial:stateCode');
    localStorage.removeItem('@UltragazEmpresarial:userCustomerRelationshipId');
    localStorage.removeItem('@UltragazEmpresarial:userName');
    localStorage.removeItem('@UltragazEmpresarial:loginCount');
    localStorage.removeItem('@UltragazEmpresarial:phone');
    this.requestGetUserInfos(token);
  };

  requestGetUserInfos = (token) => {
    const login = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    if (login) {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      api
        .get(
          `industrial/customer/v1/users/?login=${login}&is-active=true`,
          parameters
        )
        .then((res) => {
          const response = res.data[0];
          const { userId, loginCount } = response;
          localStorage.setItem(
            '@UltragazEmpresarial:loginCount',
            loginCount || ''
          );
          this.props.dispatch(handleUserId(userId));
          this.requestGetUserName(token, userId, login);
        })
        .catch((err) => {
          toast.error(err.response.data.message);
          this.setState({ loading: false });
        });
    }
  };

  requestGetUserName = (token, userId, login) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    api
      .get(
        `industrial/customer/v1/users/${userId}/contacts?contact=${login}`,
        parameters
      )
      .then((res) => {
        const response = res.data[0];
        if (response.name) {
          localStorage.setItem(
            '@UltragazEmpresarial:userName',
            response.name ? response.name : ''
          );
        }
        this.requestGetInstallbases(token, userId);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        this.setState({ loading: false });
      });
  };

  requestGetInstallbases = (token, userId) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    api
      .get(
        `industrial/customer/v1/users/${userId}/customers?&_offset=0&_limit=1000&address_type=SHIP_TO`,
        parameters
      )
      .then((res) => {
        const response = res.data;
        let adresses = [];
        response.map((address) => {
          address.customerAddress.map((base) => {
            adresses = [...adresses, { base, address }];
          });
        });
        if (adresses.length === 1) {
          const { base, address } = adresses[0];
          this.handleSelectAddress(
            base.code,
            base.siteId,
            address.customerCode,
            address.customerId,
            address.name,
            base.addressLine,
            base.addressNumber,
            base.city,
            base.stateCode,
            address.document
          );
          this.handleUserPress();
        } else {
          localStorage.setItem('@UltragazEmpresarial:haveMoreAddress', true);
        }
        this.setState({ adresses, loading: false });
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  handleSelectAddress = (
    code,
    siteId,
    customerCode,
    customerId,
    customerName,
    addressLine,
    addressNumber,
    userCustomerRelationshipId,
    city,
    stateCode,
    document
  ) => {
    localStorage.setItem('@UltragazEmpresarial:customerSiteCode', code);
    localStorage.setItem('@UltragazEmpresarial:customerSiteId', siteId);
    localStorage.setItem('@UltragazEmpresarial:customerCode', customerCode);
    localStorage.setItem('@UltragazEmpresarial:customerId', customerId);
    localStorage.setItem('@UltragazEmpresarial:customerName', customerName);
    localStorage.setItem('@UltragazEmpresarial:document', document);
    localStorage.setItem(
      '@UltragazEmpresarial:customerAddressLine',
      `${addressLine}, ${addressNumber}`
    );
    localStorage.setItem(
      '@UltragazEmpresarial:userCustomerRelationshipId',
      userCustomerRelationshipId
    );
    localStorage.setItem('@UltragazEmpresarial:city', city);
    localStorage.setItem('@UltragazEmpresarial:stateCode', stateCode);
    this.setState({ selectedAdress: code });
    if (this.state.adresses.length > 1) {
      this.changeProfile();
    }
  };

  changeValue = (value) => {
    const { adressesOrder } = this.state;

    let adressesFiltered = [];

    if (value?.length > 0) {
      adressesFiltered = adressesOrder.filter((addressItem) =>
        addressItem?.address?.name?.toLowerCase()?.includes(
          value
            ?.normalize('NFD')
            ?.replace(/[\u0300-\u036f]/g, '')
            ?.toLowerCase()
        )
      );
    } else {
      adressesFiltered = adressesOrder;
    }

    this.setState({ adressesFiltered, searchValue: value });
  };

  changeProfile = () => {
    // this.setState({ loading: true });
    const { token } = this.state;
    const userCustomerRelationshipId = localStorage.getItem(
      '@UltragazEmpresarial:userCustomerRelationshipId'
    );
    const username = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      userCustomerRelationshipId,
      username,
    };
    api
      .post('industrial/customer/v1/users/change-profile', body, parameters)
      .then((res) => {
        this.setState({ loading: false });
        const response = res.data;
        localStorage.setItem(
          '@UltragazEmpresarial:accessToken',
          response.access_token
        );
        localStorage.setItem(
          '@UltragazEmpresarial:accessToken',
          response.access_token
        );
        this.requestGetCustomer(response.access_token);
      })
      .catch((err) => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          toast.error(message);
        }
      });
  };

  handleUserPress = () => {
    this.setState({ loading: true });
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const permalink = params.get('portal');
    switch (permalink) {
      case 'boletos':
        this.setState({ permalink, link: '/boletos' });
        break;
      case 'notas':
        this.setState({ permalink, link: '/notas' });
        break;
      case 'manutencao':
        this.setState({
          permalink,
          link: '/manutencao',
        });
        break;
      case 'abastecimento':
        this.setState({
          permalink,
          link: '/abastecimento',
        });
        break;
      default:
        this.setState({ permalink: false });
        break;
    }
    this.setState({ redirect: true });
  };

  render() {
    const {
      adressesOrder,
      adressesFiltered,
      searchValue,
      loading,
      permalink,
      redirect,
      link,
    } = this.state;
    const selectedAdress = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );
    return (
      <>
        {permalink ? null : redirect ? <Redirect to="/portal" /> : null}
        {permalink ? link ? <Redirect to={link} /> : null : null}
        {loading ? (
          <Loading />
        ) : (
          <>
            <FormHeader>
              <h2>Bem-vindo ao Portal do Cliente</h2>
              <h3>
                Encontramos os seguintes endereços vinculados a sua conta.
              </h3>
              <h3>Selecione um endereço para prosseguir:</h3>
            </FormHeader>
            <AddressContainer>
              <InputSearch
                searchValue={searchValue}
                setSearchValue={(value) => {
                  this.changeValue(value);
                }}
              />
              <AddressItemContainer heightMin={adressesFiltered.length * 80}>
                {adressesFiltered.map((item) => {
                  const { base, address } = item;
                  return (
                    <>
                      <AdressItem
                        onClick={() =>
                          this.handleSelectAddress(
                            base.code,
                            base.siteId,
                            address.customerCode,
                            address.customerId,
                            address.name,
                            base.addressLine,
                            base.addressNumber,
                            address.userCustomerRelationshipId,
                            base.city,
                            base.stateCode,
                            address.document
                          )
                        }
                        key={base.code}
                        id={base.code}
                        name={base.code}
                        border={selectedAdress === base.code}
                      >
                        <Select
                          type="radio"
                          id={base.code}
                          name={base.code}
                          checked={selectedAdress === base.code}
                        />
                        <AdressInfoContainer>
                          <AdressNameContainer>
                            <AdressLine color={selectedAdress === base.code}>
                              {(address.name || '')
                                .toLowerCase()
                                .replace(/(?:^|\s)\S/g, function (a) {
                                  return a.toUpperCase();
                                })}
                            </AdressLine>
                          </AdressNameContainer>
                          <AdressLineContainer>
                            <AdressLine color={selectedAdress === base.code}>
                              {(base.addressLine || '')
                                .toLowerCase()
                                .replace(/(?:^|\s)\S/g, function (a) {
                                  return a.toUpperCase();
                                })}
                              {', '}
                              {(base.addressNumber || '')
                                .toLowerCase()
                                .replace(/(?:^|\s)\S/g, function (a) {
                                  return a.toUpperCase();
                                })}
                              {base.complement ? ' - ' : ''}
                              {(base.complement || '')
                                .toLowerCase()
                                .replace(/(?:^|\s)\S/g, function (a) {
                                  return a.toUpperCase();
                                })}
                              {' - '}
                              {(base.city || '')
                                .toLowerCase()
                                .replace(/(?:^|\s)\S/g, function (a) {
                                  return a.toUpperCase();
                                })}
                              {base.stateCode ? ' - ' : ''}
                              {(base.stateCode || '')
                                .toLowerCase()
                                .replace(/(?:^|\s)\S/g, function (a) {
                                  return a.toUpperCase();
                                })}
                            </AdressLine>
                          </AdressLineContainer>
                        </AdressInfoContainer>
                      </AdressItem>
                    </>
                  );
                })}
              </AddressItemContainer>
              {loading ? null : (
                <AddressButtonContainer>
                  {selectedAdress ? (
                    <ContainedButton
                      className="mt-4"
                      type="submit"
                      icon="account-plus"
                      text="Continuar"
                      onClick={() => this.handleUserPress()}
                      width="100%"
                      color={theme.colors.purple}
                      TrailingIcon={() => <IoMdArrowForward size={20} />}
                    >
                      Continuar
                    </ContainedButton>
                  ) : (
                    <ContainedButton
                      className="mt-4"
                      type="submit"
                      icon="account-plus"
                      text="Continuar"
                      onClick={() =>
                        toast.error('Selecione um endereço para prosseguir.')
                      }
                      width="100%"
                      color={theme.colors.purple}
                      TrailingIcon={() => <IoMdArrowForward size={20} />}
                    >
                      Continuar
                    </ContainedButton>
                  )}
                </AddressButtonContainer>
              )}
            </AddressContainer>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  url: state.signUpReducer.url,
  document: state.signUpReducer.document,
  customerCode: state.signUpReducer.customerCode,
});

export default connect(mapStateToProps)(ListAddres);
